import {
    slideUp,
    slideDown,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('.competitor-comparison-table-section.is-collapsible');

    accordionSections.forEach(section => {
        const tabRepet = section.querySelectorAll('.cct-accordion-item');

        tabRepet.forEach(tabRepetEle => {
            const title = tabRepetEle.querySelector('.cct-accordion-title');
            const content = tabRepetEle.querySelector('.cct-accordion-content');

            if (content && title) {
                title.addEventListener('click', function() {
                    const isOpen = tabRepetEle.classList.contains('is-open');

                    if (isOpen) {
                        tabRepetEle.classList.remove('is-open');
                        slideUp(content);
                    } else {
                        tabRepetEle.classList.add('is-open');
                        slideDown(content);
                    }
                });
            }
        });
    });
});
